export default __webpack_public_path__ + "static/media/pantry1-afterG-768w.34bc0ef8.avif";